// tslint:disable: max-line-length
import { checkStatus, parseJSON } from './utils';

const config = window.config;

const generateHeaders = (locale, auth) => ({
  Accept: 'application/vnd.novus+json; version=1',
  'Content-Type': 'application/json',
  'Accept-Language': locale,
  Authorization: auth
});

export const getGroups = (locale, auth, page, limit) =>
  fetch(
    `${config.REACT_APP_BASE_URL}/api/user/group?page=${page +
      1}&limit=${limit}`,
    {
      method: 'GET',
      headers: generateHeaders(locale, auth)
    }
  )
    .then(checkStatus)
    .then(parseJSON);

export const getGroupById = (locale, auth, groupId) =>
  fetch(`${config.REACT_APP_BASE_URL}/api/user/group/${groupId}`, {
    method: 'GET',
    headers: generateHeaders(locale, auth)
  })
    .then(checkStatus)
    .then(parseJSON);

export const updateGroup = (locale, auth, groupId, group) =>
  fetch(`${config.REACT_APP_BASE_URL}/api/user/group/${groupId}`, {
    method: 'PUT',
    headers: generateHeaders(locale, auth),
    body: JSON.stringify(group)
  })
    .then(checkStatus)
    .then(parseJSON);

export const searchGroups = (locale, auth, page, limit, search) => {
  return fetch(
    `${config.REACT_APP_BASE_URL}/api/user/group/search?page=${page +
      1}&limit=${limit}`,
    {
      method: 'POST',
      headers: generateHeaders(locale, auth),
      body: JSON.stringify(search)
    }
  )
    .then(checkStatus)
    .then(parseJSON);
};

export const updateGroupTranslation = (locale, auth, groupId, data) =>
  fetch(`${config.REACT_APP_BASE_URL}/api/user/group/${groupId}/translation`, {
    method: 'PUT',
    headers: generateHeaders(locale, auth),
    body: JSON.stringify(data)
  })
    .then(checkStatus)
    .then(parseJSON);

export const getAssignablePhoneRecords = (locale, auth, groupId) =>
  fetch(
    `${config.REACT_APP_BASE_URL}/api/user/group/${groupId}/phonedirectory`,
    {
      method: 'GET',
      headers: generateHeaders(locale, auth)
    }
  )
    .then(checkStatus)
    .then(parseJSON);

export const updateGroupPhoneRecords = (locale, auth, groupId, data) => {
  return fetch(
    `${config.REACT_APP_BASE_URL}/api/user/group/${groupId}/phonedirectory`,
    {
      method: 'POST',
      headers: generateHeaders(locale, auth),
      body: JSON.stringify(data)
    }
  )
    .then(checkStatus)
    .then(parseJSON);
};

export const createGroup = (locale, auth, data) => {
  return fetch(`${config.REACT_APP_BASE_URL}/api/user/group`, {
    method: 'POST',
    headers: generateHeaders(locale, auth),
    body: JSON.stringify(data)
  })
    .then(checkStatus)
    .then(parseJSON);
};

export const getOwnedPhoneRecords = (locale, auth, groupId) =>
  fetch(`${config.REACT_APP_BASE_URL}/api/user/phonedirectory/${groupId}`, {
    method: 'GET',
    headers: generateHeaders(locale, auth)
  })
    .then(checkStatus)
    .then(parseJSON);

export const getProducts = (
  locale,
  authorization,
  groupId = '00000000-0000-0000-0000-000000000000'
) =>
  fetch(`${config.REACT_APP_BASE_URL}/api/user/group/${groupId}/products`, {
    method: 'GET',
    headers: generateHeaders(locale, authorization)
  })
    .then(checkStatus)
    .then(parseJSON);

export const getAvailableProducts = (
  locale,
  authorization,
  parentGroupId,
  groupId
) =>
  fetch(
    `${config.REACT_APP_BASE_URL}/api/user/group/availableproducts/?parentGroupId=${parentGroupId}&groupId=${groupId}`,
    {
      method: 'GET',
      headers: generateHeaders(locale, authorization)
    }
  )
    .then(checkStatus)
    .then(parseJSON);



// WEBPACK FOOTER //
// ./src/api/groups.js